<script lang="ts" setup>
import { computed, inject, onMounted, ref, watch } from 'vue'
import { useConfigStore, useLoadingStore, useToastStore } from '@/stores'
import { KS } from '@/kuaishou'
import { api } from '@/api'
import { $log } from '@/helpers'
import { track } from '@/track'

defineProps<{
  value: boolean
}>()
const emit = defineEmits<{
  (event: 'input', value: boolean): void
}>()

// Inject
const theme = inject<{ background: string }>('theme', { background: 'white' })
const configStore = useConfigStore()

const { $showLoading, $hideLoading } = useLoadingStore()
const { $toast } = useToastStore()

const modal = ref(true)
const backgroundModules = import.meta.glob('@/assets/modal-welfare-background-*.png', { eager: true, as: 'url' })
const background = computed(() => {
  const index = Math.floor(Math.random() * 3) // // 0, 1, 2
  const backgrounds = Object.values(backgroundModules)
  return backgrounds[index]
})
const adVideoPlayer = ref(false)
const adVideoData = ref<{ sessionId: string; src: string; poster: string; isDownload: boolean; [key: string]: any }>({ sessionId: '', src: '', poster: '', isDownload: false })

const coin = ref(0)
onMounted(async () => {
  try {
    const { data } = await api.post('/kuaishou/ad/inspireNovelAbTest', ['col_ad_video_inspire_reward'])
    const parts = data.abResult.col_ad_video_inspire_reward.split('&')
    const params: Record<string, string> = {}
    for (const part of parts) {
      const [key, value] = part.split('=')
      params[key] = value
    }
    if (!params.gold)
      throw new Error('missing `gold` value')
    coin.value = Number(params.gold)
  }
  catch (error) {
    $log('Component: BizModalWelfare', '#onMounted', { error })
    coin.value = configStore.$state.adPopupFuliInspireNum
  }
})

async function onReceive() {
  $log('Component: BizMOdalWelfare', '#onReceive')
  $showLoading()
  try {
    track('inspireVideo', { name: 'insertWelfare', type: 'start' })
    await KS.playAdVideo({
      type: 3,
      extParams: {
        scene: 'colEnableImageAdVideo',
      },
      success(data: any) {
        track('inspireVideo', { name: 'insertWelfare', type: 'end' })
        $log('Component: BizMOdalWelfare', '#onReceive ~> success', { data })
        $toast('看完广告视频, 金币领取成功')
        emit('input', false)
      },
      fail(error: any) {
        track('inspireVideo', { name: 'insertWelfare', type: 'cancel' })
        $log('Component: BizMOdalWelfare', '#onReceive ~> fail', { error })
        $toast('未看完视频，无法领取奖励')
        emit('input', false)
      },
    })
    // modal.value = false
  }
  catch {}
  finally {
    $hideLoading()
  }
}

const countdowning = ref(true)
function onEndCountdown() {
  countdowning.value = false
}
function onContinue() {
  emit('input', false)
}

watch(() => [modal.value, adVideoPlayer.value], () => {
  if (!modal.value && !adVideoPlayer.value)
    emit('input', false)
})

function onCancelAdVideo() {
  $toast('未看完视频，红包飞走了')
}
function onEndAdVideo() {
  $toast('看完广告视频, 金币领取成功')
  emit('input', false)
}
</script>

<template>
  <portal to="root" :order="10">
    <BizTrackShow
      v-if="modal" name="insertWelfare" type="page" :delay="1.5"
      :extra="{ gold: coin, theme: background }"
      class="px-10 flex flex-col justify-center fixed inset-0 z-100"
      :style="{ background: theme.background }"
    >
      <p class="-mt-10vh flex items-center justify-center space-x-2 text-#999 text-xl">
        <span class="w-10 h-1px" style="background: linear-gradient(270deg, #939393 0%, rgba(217, 217, 217, 0.00) 99.98%);" />
        <span>限时福利</span>
        <span class="w-10 h-1px" style="background: linear-gradient(270deg, rgba(217, 217, 217, 0.00) 0%, #939393 99.98%);" />
      </p>
      <div class="mt-12 w-full relative">
        <img class="w-full" :src="background" @click="onReceive">
        <p class="flex items-baseline whitespace-nowrap text-primary absolute top-1/2 left-1/2 -translate-1/2">
          <span class="text-xl font-bold relative -top-2">送你</span>
          <span class="mx-2 text-75px lh-1em font-bold">{{ coin === 0 ? '...' : coin }}</span>
          <span class="text-xl font-bold relative -top-2">金币</span>
        </p>
      </div>
      <div class="fixed w-full left-0 bottom-8 text-center text-sm text-#999">
        <BasicCountdown v-if="countdowning" :seconds="configStore.$state.pageDwellTime" @end="onEndCountdown">
          <template #default="{ seconds }">
            {{ seconds }} 秒后可继续阅读下一页
          </template>
        </BasicCountdown>
        <span v-else @click="onContinue">
          放弃奖励, 继续阅读下一章
        </span>
      </div>
    </BizTrackShow>

    <!-- <BizAdVideoPlayer
      v-if="adVideoPlayer"
      v-model="adVideoPlayer" :session-id="adVideoData.sessionId"
      :src="adVideoData.src" :poster="adVideoData.poster" :caption="adVideoData.caption"
      :is-download="adVideoData.isDownload" :action-bar="adVideoData.actionBar" :action-bar-color="adVideoData.actionBarColor"
      @end="onEndAdVideo" @cancel="onCancelAdVideo"
    /> -->
  </portal>
</template>
